import { render, staticRenderFns } from "./cardSettings.vue?vue&type=template&id=dd74ff04&scoped=true&"
import script from "./cardSettings.vue?vue&type=script&lang=js&"
export * from "./cardSettings.vue?vue&type=script&lang=js&"
import style0 from "./cardSettings.vue?vue&type=style&index=0&id=dd74ff04&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd74ff04",
  null
  
)

export default component.exports